// (B) 플레인 Radio — antd Radio/Radio.Group 대체(순수 시각). antd DOM 미러링:
// .om-radio-group > label.om-radio-wrapper > span.om-radio(+.om-radio-checked) > input.om-radio-input + span.om-radio-inner / span.om-radio-label.
// 선택 상태는 Context 로 group→radio 전파. 소비처 SCSS(.om-radio*)가 시각 정의 → 여기선 구조+antd base(styles/omRadio.css).
import { createContext, useContext, useState } from 'react'
import type { OmwRadioGroupProps, OmwRadioProps, OmwRadioValue } from '../api/OmwRadioGroup'
import { cx } from './cx'
import '../styles/omwRadio.css'

interface RadioGroupCtx {
  value?: OmwRadioValue
  name?: string
  onSelect: (value: OmwRadioValue) => void
}

const RadioGroupContext = createContext<RadioGroupCtx | null>(null)

export function PlainRadioGroup({
  value,
  defaultValue,
  onChange,
  name,
  className,
  style,
  children,
}: OmwRadioGroupProps) {
  const [internal, setInternal] = useState<OmwRadioValue | undefined>(defaultValue)
  const isControlled = value !== undefined
  const current = isControlled ? value : internal

  const onSelect = (next: OmwRadioValue) => {
    if (!isControlled) setInternal(next)
    onChange?.(next)
  }

  return (
    <div className={cx('om-radio-group', className)} style={style}>
      <RadioGroupContext.Provider value={{ value: current, name, onSelect }}>
        {children}
      </RadioGroupContext.Provider>
    </div>
  )
}

export function PlainRadio({ value, disabled, children }: OmwRadioProps) {
  const ctx = useContext(RadioGroupContext)
  const checked = ctx?.value === value

  return (
    <label
      className={cx(
        'om-radio-wrapper',
        checked && 'om-radio-wrapper-checked',
        disabled && 'om-radio-wrapper-disabled',
      )}
    >
      <span
        className={cx('om-radio', checked && 'om-radio-checked', disabled && 'om-radio-disabled')}
      >
        <input
          type="radio"
          className="om-radio-input"
          name={ctx?.name}
          value={String(value)}
          checked={checked}
          disabled={disabled}
          onChange={() => ctx?.onSelect(value)}
        />
        <span className="om-radio-inner" />
      </span>
      {children !== undefined && <span className="om-radio-label">{children}</span>}
    </label>
  )
}
